<template>
  <div class="about">
    <v-container>
      <!-- *******************row 1 ********************-->
      <v-row class="mt-0 mt-sm-12" align="center">
        <!-- col mobile -->
        <v-col cols="12" sm="8" class="d-sm-none pa-0">
          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.cover.path" class></v-img>
        </v-col>
        <!-- /col mobile -->

        <v-col cols="12" sm="3">
          <v-img
            :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.logo1.path"
            class="img-la-made about-section"
          ></v-img>
        </v-col>
        <v-col cols="12" sm="8" offset-sm="1">
          <div v-html="aboutSingleton.first_description" class="description-about"></div>
        </v-col>
      </v-row>
      <!-- *******************/row 1 ********************-->

      <!-- *******************row 2 ********************-->
      <v-row align="center">
        <v-col cols="12" sm="3">
          <v-img
            :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.logo2.path"
            class="img-la-made about-section"
          ></v-img>
        </v-col>

        <!-- col tablet to up -->
        <v-col cols="12" sm="8" offset-sm="1" class="d-none d-sm-block">
          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.cover.path" class></v-img>
        </v-col>
        <!-- col tablet to up -->
      </v-row>
      <!-- *******************/row 2 ********************-->

      <!-- *******************row 3 ********************-->
      <v-row class="mt-12">
        <v-col cols="12" sm="3">
          <div class=" text-center">
            <span class="uppercase gtAmerica-bold title-about">{{aboutSingleton.title}}</span>
          </div>


          
          

        </v-col>
        <v-col cols="12" sm="8" offset-sm="1">
          <div v-html="aboutSingleton.second_description" class="description-about"></div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="3">
          <div class="column-5-hover">
            <div>
              <v-img :src="'https://artlesscms.actstudio.xyz/'+aboutSingleton.founder_image.path"></v-img>
            </div>
            <div class="overlay5">
              <div class="text-overlay5">
                <div>
                  <span class="white--text title-app about-section-title">Alejandro Artigas</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">Founder</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" sm="8" offset-sm="1">

          <div v-html="aboutSingleton.founder_text" class="description-about"></div>
        </v-col>

      </v-row>
      <!-- *******************/row 3 ********************-->

      <!-- *******************row 4 ********************-->
      <v-row class="mt-0 mt-sm-12 mb-12">
        <v-col cols="6" sm="3">
          <div class="column-1-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_1.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay1">
              <div class="text-overlay1">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_1.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_1.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-2-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_2.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay2">
              <div class="text-overlay2">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_2.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_2.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-3-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_3.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay3">
              <div class="text-overlay3">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_3.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_3.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-4-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_4.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay4">
              <div class="text-overlay4">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_4.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_4.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-5-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_5.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay5">
              <div class="text-overlay5">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_5.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_5.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-6-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_6.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay6">
              <div class="text-overlay6">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_6.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_6.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-7-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_7.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay7">
              <div class="text-overlay7">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_7.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_7.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="6" sm="3">
          <div class="column-8-hover">
            <div>
              <v-img
                :src="'https://www.artlesscms.actstudio.xyz/'+aboutSingleton.member_8.coverMember.path"
              ></v-img>
            </div>
            <div class="overlay8">
              <div class="text-overlay8">
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_8.name}}</span>
                </div>
                <div class="separator"></div>
                <div>
                  <span class="white--text title-app about-section-title">{{aboutSingleton.member_8.position}}</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- *******************/row 4 ********************-->
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      aboutSingleton: {},
    };
  },
  beforeMount() {
    //fetch to get the singleton "about"
    fetch(
      "https://www.artlesscms.actstudio.xyz/api/singletons/get/about?token=a15be93e9cdb43ca2b3778c2077c26"
    )
      .then((data) => data.json())
      .then((data) => (this.aboutSingleton = data));
  },
  mounted: function(){
    var breadcrumbs = [
        {
            text: 'Home',
            link: '/',
            isLink: true
        },
        {
            text: 'About',
            link: '/about',
            isLink: false
        }
    ];
    this.$emit("updateStatus", breadcrumbs);
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'About',
      'page_path': '/about'
    });
  }
};
</script>
